import { MOBILE_SOURCES } from '@/pages/intelligence/_config/storeRank/config';

export const COMPARE_MOBILE_SOURCES = [...MOBILE_SOURCES, 'googleplay top new free', 'googleplay top new paid'];

export const DEFAULT_DATASOURCES = [
  'appstore top free',
  'appstore top grossing',
  'googleplay top free',
  'googleplay top grossing',
];

export const DEFAULT_DATASOURCES_SIM = ['appstore top free'];

export const DEFAULT_FILTER_PARAMS = {
  regionType: 'markets',
  regionValue: ['us'],
  selectedType: 'multiple',
  dataSourceSim: DEFAULT_DATASOURCES_SIM,
  dataSourceMul: DEFAULT_DATASOURCES,
  dataSource: DEFAULT_DATASOURCES_SIM,
  showHeatMap: false,
};
